import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Box, Flex } from '../../../../units/Box/Box';
import Button from '../../../../units/Button/Button';
import Text from '../../../../units/Text/Text';

import { FormTitle } from '../../FormUnits/FormUnits';

import Icon from '../../../../units/Icon/Icon';

const CloseIcon = styled(Icon).attrs({
  icon: 'error'
})`
  position: absolute;
  height: 64px;
  width: 64px;
  z-index: ${props => props.theme.zIndexes.modal};
  top: -44px;
  left: -94px;
`;

const RelativeWrapper = styled(Box)`
  position: relative;
`;

const PasswordForm = ({ fields, applyAction, renderHeader, params }) => {
  const close = () => {
    applyAction({
      actionId: '_close'
    });
  };

  const Title = () => (
    <Box>
      <FormTitle className="form-title_user-information">
        {params.title}
      </FormTitle>
    </Box>
  );

  return (
    <Box pl="109px">
      {renderHeader({ title: <Title /> })}
      <RelativeWrapper className="ErrorForm__BodyWrapper" mt="15px">
        <CloseIcon />
        <Text>{fields.message.value}</Text>
      </RelativeWrapper>
      <Flex mt="25px" justify="flex-end">
        <Button size="medium" font="caption" onClick={close} bold>
          Закрыть
        </Button>
      </Flex>
    </Box>
  );
};

PasswordForm.propTypes = {
  applyAction: PropTypes.func.isRequired,
  renderHeader: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired
};

export default PasswordForm;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormsComponents/ErrorForm/ErrorForm.js